<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="success"
      title="Payroll Bank"
      text="Edit Payroll Bank"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="localPayrollBank.name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="localPayrollBank.shift_code"
                v-validate="'required'"
                :error-messages="errors.collect('shift_code')"
                data-vv-name="shift_code"                
                data-vv-as="shift code"                
                label="Shift Code"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="localPayrollBank.bank_code"
                label="Bank Code"
              />
            </v-col>
            <v-col cols="12">
              <span> Is Template Ready? </span>
              <v-radio-group
                v-model="localPayrollBank.is_template_ready"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
              </v-radio-group>
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      payrollBank: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        localPayrollBank: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return
        this.localPayrollBank = { ...this.payrollBank }
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.payrollBanks().update(this.payrollBank.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.dialog = false
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        let data = { 
          name: this.localPayrollBank.name,
          shift_code: this.localPayrollBank.shift_code,
          bank_code: this.localPayrollBank.bank_code,
          is_template_ready: this.localPayrollBank.is_template_ready,
        }
        return data
      },
    },
  }
</script>
